import { Reducer } from '../../../../@types';
import { SharePointTypes } from '../../../../@types/enums';
import { initialState, SharePointState } from './initialState';

// @ts-ignore
export const sharepointReducer: Reducer<SharePointState> = (
  state = initialState,
  action
) => {
  switch (action.type as any) {
    case SharePointTypes.SHAREPOINT_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SharePointTypes.SHAREPOINT_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload,
        loading: false,
      };
    case SharePointTypes.SHAREPOINT_SETTINGS_FAILURE:
      return {
        ...state,
        error: (action.error as any)?.message || action.error,
        loading: false,
      };

    case SharePointTypes.SHAREPOINT_SITES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SharePointTypes.SHAREPOINT_SITES_SUCCESS:
      return {
        ...state,
        sites: action.payload,
        loading: false,
      };
    case SharePointTypes.SHAREPOINT_SITES_FAILURE:
      return {
        ...state,
        error: (action.error as any)?.message || action.error,
        loading: false,
      };

    case SharePointTypes.SHAREPOINT_DRIVES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SharePointTypes.SHAREPOINT_DRIVES_SUCCESS:
      return {
        ...state,
        drives: action.payload,
        loading: false,
      };
    case SharePointTypes.SHAREPOINT_DRIVES_FAILURE:
      return {
        ...state,
        error: (action.error as any)?.message || action.error,
        loading: false,
      };

    case SharePointTypes.SHAREPOINT_SAVE_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
      };
    case SharePointTypes.SHAREPOINT_SAVE_SUCCESS:
      return {
        ...state,
        grantResult: action.payload,
        saving: false,
      };
    case SharePointTypes.SHAREPOINT_SAVE_FAILURE:
      return {
        ...state,
        error: (action.error as any)?.message || action.error,
        saving: false,
      };

    case SharePointTypes.SHAREPOINT_SET_SELECTED_SITE:
      return {
        ...state,
        selectedSite: action.payload,
      };
    case SharePointTypes.SHAREPOINT_SET_SELECTED_DRIVE:
      return {
        ...state,
        selectedDrive: action.payload,
      };
    case SharePointTypes.SHAREPOINT_SET_FOLDER_PATH:
      return {
        ...state,
        folderPath: action.payload,
      };

    case SharePointTypes.SHAREPOINT_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
